import { Hero } from '@zoopla-eng/zds-components/hero';
import { ErrorNoResults } from '@zoopla/assets';
import { Stack } from '@zoopla-eng/zds-components/stack';
import {
    errorTitleStyle,
    errorTextStyle,
    illustrationStyle
} from './ErrorBanner.styles.css';

import { fontGroups } from '@zoopla-eng/zds-components/themes';

type ErrorBannerProps = React.PropsWithChildren<{ title: string }>;

export function ErrorBanner({ title, children }: ErrorBannerProps) {
    return (
        <Hero bg="graphicErrorPageDay" px={0}>
            <Stack>
                <h1 className={`${errorTitleStyle} ${fontGroups.teapot}`}>
                    {title}
                </h1>
                <div className={`${errorTextStyle} ${fontGroups.ladle}`}>
                    {children}
                </div>
                <img
                    className={illustrationStyle}
                    src={ErrorNoResults}
                    alt={'Error'}
                />
            </Stack>
        </Hero>
    );
}
